/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: measures.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Measures Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import "./variable/v";
import * as GC from "../../../common/common";
import $ from "jquery";
import Table from "./Table";
import Detail from "./Detail";
import Edit from "./Edit";
import RowDeleteModal from "../../modal/rowDelete";
import ActiveerMaatregelModal from "./modals/ActiveerMaatregelModal";
import AddMeasuresModal from "./modals/AddMeasuresModal";
import Grootboek from "./modals/Grootboek";
import KoppelenDisciplineModal from "./modals/KoppelenDisciplineModal";
import Bewerkprijsperuitvoerder from "./modals/bewerkprijsperuitvoerder";
import KoppelenWerkbron from "./modals/KoppelenWerkbron";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";

class Measures extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: [],
    };
  }

  async componentDidMount() {
    /*** Popup kaldırmak için
     *   kullanılıyor ***/
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });
  }
  /*****END ---REACT LIFE CYCLE FUNCTIONS--- END******/

  render() {
    return (
      <div>
        <div className="border p-3 br5 full-width" id="border-mid">
          <Table {...this.props} />
          <Detail />
          <Edit selectOpstions={this.state.selectOptions} />
          <ActiveerMaatregelModal />
          <AddMeasuresModal />
          <Grootboek />
          <KoppelenDisciplineModal />
          <Bewerkprijsperuitvoerder />
          <KoppelenWerkbron />
          <RowDeleteModal
            id="measures-mappen_beheren_delete_modal"
            handleDelete={CommonFunctions.rowsHandleDelete}

            // buttonId="measures-rows-delete-modal"
          />
        </div>
      </div>
    );
  }
}

export default Measures;
